import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { formatMoney } from '../../../../util/currency';
import Products from './Products';
import LongTermDiscount from './LongTermDiscount';
import PromoDiscount from './PromoDiscount';
import EveningDiscount from './EveningDiscount';
import PartnershipDiscount from './PartnershipDiscount';

import css from '../../OrderItemInfo.css';

const ListingsItem = ({
  intl,
  idMessage,
  children,
  key,
  products,
  listings,
  longTermDiscount,
  eveningDiscount,
  promoDiscount,
  partnershipDiscount,
  money
}) => {

  return (
    <div key={key}>
      {children}
      <Products
        products={products}
        listings={listings}
        intl={intl}
      />
      <EveningDiscount discount={eveningDiscount} intl={intl} />
      <LongTermDiscount discount={longTermDiscount} intl={intl} />
      <PromoDiscount discount={promoDiscount} intl={intl} />
      <PartnershipDiscount discount={partnershipDiscount} intl={intl} />
      <p className={classNames(css.subtitle, css.priceContainer, css.borderBottom)}>
        <FormattedMessage id={idMessage} /> {formatMoney(intl, money)}
      </p>
    </div>
  );
}

export default ListingsItem;
